<div class="detail-container">
  <div class="section container-fluid col-md-11 justify-content-center" fxLayoutGap="grid">
    <div class="row">
      <div class="col">
        <ng-container *ngTemplateOutlet="timestamps"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ng-container *ngTemplateOutlet="rejects"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ng-container *ngTemplateOutlet="cancellation"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ng-container *ngTemplateOutlet="assignements"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ng-container *ngTemplateOutlet="validation"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ng-container *ngTemplateOutlet="check"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ng-container *ngTemplateOutlet="workflows"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ng-container *ngTemplateOutlet="CancellationProcessReason"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ng-container *ngTemplateOutlet="LogPPR"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ng-container *ngTemplateOutlet="nonERPvalidation"></ng-container>
      </div>
    </div>
    <br> <br>
  </div>

  <div fxLayout=”row” fxLayoutAlign="end" class="bottom-bar">
    <div fxLayout=”row” fxLayoutAlign="end">
      <div class="btnSpacerCol">
        <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Retour au détail" (click)="onBackToDetail()">
          <mat-icon>keyboard_return</mat-icon>
          <span class="long-btn-span large" fxHide fxShow.gt-md>Retour au détail</span>
        </button>
      </div>
      <div class="btnSpacerCol">
        <button mat-stroked-button class="currentBtnColor" matTooltip="Retour à la liste" (click)="onBackToList()">
          <mat-icon>keyboard_return</mat-icon>
          <span class="long-btn-span large" fxHide fxShow.gt-md>Retour à la liste</span>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #assignements>
  <div class="card" *ngIf="InvoiceTraceability?.Assignments">
    <div class="card-header card-title">Groupe d'affectation</div>
    <div class="card-body">
      <div class="row item-container" *ngFor="let assignment of InvoiceTraceability.Assignments | orderBy:'Date':'asc'">
        <div class="col-auto mr-auto item-value">
          {{assignment.Name}}
        </div>
        <div class="col-auto mr-auto item-value">
          {{assignment.UserFullName}}
        </div>
        <div class="col-auto item-comment">
          {{assignment.Comment}}
        </div>
        <div class="col-auto item-valueDate">
          {{assignment.Date | date: 'dd-MM-yyyy HH:mm:ss'}}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #timestamps>
  <div class="card">
    <div class="card-header card-title">Statuts</div>
    <div class="card-body">
      <div class="row item-container">
        <div class="col-auto mr-auto label">OCR</div>
        <div class="col-auto item-valueDate">
          {{InvoiceTraceability?.Timestamps?.OcrDate | date: 'dd/MM/yyyy HH:mm:ss'}}
        </div>
      </div>
      <div class="row item-container">
        <div class="col-auto mr-auto label">Import</div>
        <div class="col-auto item-valueDate">
          {{InvoiceTraceability?.Timestamps?.ImportDate | date: 'dd/MM/yyyy HH:mm:ss'}}
        </div>
      </div>
      <hr>
      <div class="row item-container" *ngFor="let audit of InvoiceTraceability?.AuditStageChanges  | orderBy:'Date':'asc'">
        <div class="col-auto mr-auto label">
          <div>{{audit.State | invoiceState}}</div>
        </div>
        <div class="col-auto item-valueDate">
          <span *ngIf="audit.IsAdmin" class="material-icons item-valueDate" tooltip="Intervention Admin">support_agent</span>
          {{audit.Date |
          date: 'dd/MM/yyyy HH:mm:ss'}}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #cancellation>
  <div class="card" *ngIf="InvoiceTraceability?.CancellationHistory?.Username">
    <div class="card-header card-title">Annulation</div>
    <div class="card-body">
      <div class="row item-container">
        <div class="col-auto mr-auto">
          {{InvoiceTraceability?.CancellationHistory?.Username}}
        </div>
        <div class="col-auto item-valueDate">
          {{InvoiceTraceability?.CancellationHistory?.CancellationDate | date: 'dd/MM/yyyy HH:mm:ss'}}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #validation>
  <div class="card" *ngIf="InvoiceTraceability?.ProcessValidation">
    <div class="card-header card-title">Validation du traitement</div>
    <div class="card-body">
      <div class="row">
        <div class="col-auto mr-auto">
          {{InvoiceTraceability?.ProcessValidation?.UserName}}
        </div>
        <div class="col-auto item-valueDate">
          {{InvoiceTraceability?.ProcessValidation?.ValidationDate | date: 'dd/MM/yyyy HH:mm:ss'}}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #check>
  <div class="card" *ngIf="InvoiceTraceability?.Check">
    <div class="card-header card-title">Validation du contrôle</div>
    <div class="card-body">
      <div class="row">
        <div class="col-auto mr-auto">
          {{InvoiceTraceability?.Check?.UserName}}
        </div>
        <div class="col-auto item-valueDate">
          {{InvoiceTraceability?.Check?.ValidationDate | date: 'dd/MM/yyyy HH:mm:ss'}}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #nonERPvalidation>
  <div class="card" *ngIf="InvoiceTraceability?.VoucherValidation">
    <div class="card-header card-title">Traitement comptable</div>
    <div class="card-body">
      <div class="row item-container">
        <div class="col-auto mr-auto">
          {{InvoiceTraceability?.VoucherValidation?.UserName}}
        </div>
        <div class="col-auto item-valueDate">
          {{InvoiceTraceability?.VoucherValidation?.ValidationDate | date: 'dd/MM/yyyy HH:mm:ss'}}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #rejects>
  <div class="card" *ngIf="InvoiceTraceability?.RejectionHistory.length">
    <div class="card-header">Renvoi par email</div>
    <div class="card-body">
      <div class="row" *ngFor="let rejectionHistory of InvoiceTraceability.RejectionHistory  | orderBy:'Date':'asc'">
        <div class="col-xs-12 full-width">
          <mat-accordion multi class="full-width">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <div class="row full-width">
                  <div class="col-auto mr-auto">
                    {{rejectionHistory.UserName}}
                  </div>
                  <div class="col-auto item-valueDate">
                    {{rejectionHistory.Date | date: 'dd-MM-yyyy HH:mm:ss'}}
                  </div>
                </div>

              </mat-expansion-panel-header>
              <hr>
              <div class="item-container">
                Envoyé à :
                <mat-chip-listbox>
                  <mat-chip-option color="primary" *ngFor="let recipient of rejectionHistory.Email?.RecipientsTo">{{recipient}}
                  </mat-chip-option>
                </mat-chip-listbox>
              </div>
              <div class="jumbotron overflow-auto">
                <div class="mail-title">
                  <strong>Objet : </strong>
                  {{rejectionHistory.Email?.Title}}
                </div>

                <div class="mail-content"><strong>Message : </strong></div>
                <div [innerHTML]="rejectionHistory.Email?.Content"></div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #workflows>
  <app-invoice-traceability-workflows [InvoiceTraceability]="InvoiceTraceability">
  </app-invoice-traceability-workflows>
</ng-template>

<ng-template #LogPPR>
  <div class="card" *ngIf="InvoiceTraceability?.PPRLogs.length">
    <div class="card-header card-title">Logs PPR</div>
    <div class="card-body">
      <div class="row item-container" *ngFor="let log of InvoiceTraceability.PPRLogs | orderBy:'Date':'asc'">
        <div class="col-8 mr-auto">
          {{ log.LogValue }}
        </div>
        <div class="col-2 mr-auto">
          {{ log.User }}
        </div>
        <div class="col-auto item-valueDate">
          {{ log.Date | date: 'dd-MM-yyyy HH:mm:ss' }}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #CancellationProcessReason>
  <div class="card" *ngIf="InvoiceTraceability?.CancelReason">
    <div class="card-header card-title">Motif de l'annulation du comptable</div>
    <div class="card-body">
      <div class="row item-container" *ngFor="let cancel of InvoiceTraceability.CancelReason | orderBy:'Date':'asc'">
        <div class="col-8 mr-auto">
          {{ cancel.Reason }}
        </div>
        <div class="col-2 mr-auto">
          {{ cancel.Username }}
        </div>
        <div class="col-auto item-valueDate">
          {{ cancel.CancellationDate | date: 'dd-MM-yyyy HH:mm:ss' }}
        </div>
      </div>
    </div>
  </div>
</ng-template>